import React from 'react';
import { clsx } from 'clsx';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger } from 'src/components/ui/select';

export const TicketStatusSelect = <T extends FieldValues>({
  name = '' as Path<T>,
  label,
  control,
  options = [],
}: {
  name?: Path<T>;
  label: React.ReactNode;
  control: Control<T>;
  options?: { id: string | number | null; agent_label: string }[];
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <label htmlFor={name}>
            {label}
            <Select
              defaultValue={value}
              open={open}
              onOpenChange={setOpen}
              onValueChange={onChange}
            >
              <SelectTrigger className="w-full bg-white border border-[#E3E6E8] rounded-sm-5">
                <div>
                  <p className={'text-sm font-medium first-letter:capitalize'}>
                    <span>
                      {options.find((option) => `${option.agent_label}` === value)?.agent_label ||
                        options[0].agent_label}
                    </span>
                  </p>
                </div>
              </SelectTrigger>
              <SelectContent className={'bg-light'}>
                {options.map((option) => {
                  return (
                    <SelectItem
                      className={'px-4 rounded-none bg-white hover:!bg-[#a498ff1a]'}
                      key={option.id}
                      value={option.agent_label}
                      indicatorHidden
                    >
                      <div className="flex flex-col">
                        <div className="flex gap-2 items-center">
                          <p
                            className={clsx(
                              'text-sm text-start relative first-letter:capitalize',
                              `${option.agent_label}` === value ? 'font-semibold' : 'font-medium',
                            )}
                          >
                            <span>{option.agent_label}</span>
                          </p>
                        </div>
                      </div>
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          </label>
        );
      }}
    />
  );
};
